module.exports = __webpack_public_path__ + "img/megaphone.d191cc76.svg";